export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6111.c2e0c1e1.jpg";